module.exports = __webpack_public_path__ + "img/banner-7.c6875656.jpg";